// extracted by mini-css-extract-plugin
module.exports = {"text":"styles_text__1ZUPe","paragraph":"styles_paragraph__1IHL6","list":"styles_list__fXZmE","link":"styles_link__3zfFK"};